export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5413.f726fab5.jpg";